import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import DriveCharge, { PAGE_TYPE } from '@elem/compCommon/DriveCharge';
import css from './index.module.scss';
import MallBanner from './mallBanner';
import HomeVideo from './h5/homeVideo';
import VideoAniA from './h5/videoAniA';
import OtherProduct from './h5/otherProduct';
import HowPreparesSwiper from './h5/howPreparesSwiper';
import HowPrepares from './h5/howPrepares';
import ImgA from './h5/imgA';
import IconContent from './h5/iconContent';
import MultiCharge from './h5/multicharge';
import MsgA from './h5/msgA';
import ImgB from './h5/imgB';
import GrowingEco from './h5/growingEco';
import BuiltLonger from './h5/builtLonger';
import ThreeVideo from './h5/threeVideo';
import OtherFeatures from './h5/otherFeatures';
import ProsThink from './h5/prosThink';
import { AUTO_SWITCH_COUNTRIES, SHOW_PROS_THINK } from './Delta2Pc';
import FeaturedIn from './featuredIn';
import AUBanner from './h5/auBanner';
import CalculatorModule from './calculatorModule';
import OtherList from '@/components/ProductCommon/OtherList';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import ScrollMagicFn from '@/utils/ScrollMagic';

if (typeof window !== 'undefined') {
    window.ScrollMagic = ScrollMagicFn();
    ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    window.controllerDelta2 = new ScrollMagic.Controller();
}
const list = {
    br: ['product_ps_delta_delta_pro_plus', 'product_ps_delta_delta_2_max', 'product_ps_river_river_256'],
    mx: ['product_ps_delta_delta_3_s', 'product_ps_delta_delta_pro', 'product_ps_river_river_256'],
    ph: ['product_ps_river_river_256', 'product_ps_delta_delta_2_max', 'product_ps_delta_delta_3'],
    en: ['product_ps_delta_delta_pro', 'product_ps_delta_delta_max', 'product_ps_river_river_256'],
};
export default function Delta2({ theme }: any) {
    const { useEffect, gloproductlist, useRouter, useLang } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstation');
    const otherProductData = getDetaileMoreProducts(
        gloproductlist,
        list?.[locale as 'en'] ?? list['en'],
        '',
        '',
        ['br'].includes(locale)
            ? 'https://br.ecoflow.com/collections/delta-series-portable-power-stations'
            : `https://${locale}.ecoflow.com/collections/portable-power-stations`,
    );
    const AU_SITE = ['au'].includes(locale);

    useEffect(() => {
        return () => {
            setTimeout(() => {
                /* @ts-ignore */
                window.controllerDelta2?.destroy(true);
            }, 30);
        };
    }, []);

    return (
        <div className={`${css.delta2H5} delta2H5`}>
            {!AU_SITE && (AUTO_SWITCH_COUNTRIES.includes(locale) ? <MallBanner /> : <HomeVideo />)}
            {AU_SITE && <AUBanner />}
            <VideoAniA />
            <OtherProduct />
            <HowPreparesSwiper />
            <HowPrepares />
            <ImgA />
            <MsgA />
            <IconContent />
            {locale === 'za' && <CalculatorModule />}
            <div
                className="top-up title-bolder"
                style={{
                    fontSize: '0.36rem',
                    lineHeight: '0.44rem',
                    fontFamily: 'var(--font-family-ExtraBold)',
                    whiteSpace: 'pre-line',
                    padding: '1.3rem 0.35rem 0.46rem',
                    color: '#fff',
                }}
            >
                {t('delta2.aniF_msg3')}
            </div>
            {AU_SITE && (
                <>
                    <ImgB />
                    <MultiCharge />
                </>
            )}
            {!AU_SITE && (
                <>
                    <MultiCharge />
                    <ImgB />
                </>
            )}
            <DriveCharge locale={locale} pageType={PAGE_TYPE.DELTA_2} />
            <BuiltLonger />
            <ThreeVideo />
            <GrowingEco />
            {SHOW_PROS_THINK.includes(locale) && (
                <>
                    <ProsThink />
                    <FeaturedIn />
                </>
            )}
            <OtherFeatures />
            <OtherList data={otherProductData} theme={theme} />
        </div>
    );
}
